import React, { Component } from "react";

class Panel extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		const { className, children } = this.props;

		const style = ["panel-component", className].join(" ");

		return <div className={style}>{children}</div>;
	}
}

export default Panel;
